module.exports = {
    PAGES_MANIFEST: 'pages-manifest.json',
    BUILD_MANIFEST: 'build-manifest.json',
    BUILD_ID_FILE: 'BUILD_ID',
    HOME_CONSTRUCTOR_NAME: 'index',
    PAGE_ID_PREFIX: '__PAGE__',
    DEFAULT_USER_SETTINGS: {
        theme: 'light',
        textSize: 'm',
        showMiniToc: true,
        wideFormat: true,
        fullScreen: false,
    },
    SERVICES_PREFIX: 'services/',
    SOLUTIONS_PREFIX: 'solutions/',
    MARKETPLACE_PREFIX: 'marketplace/',
    GEO_DATA_COOKIE_NAME: 'session-geo-data',
};
